import TableForm from "@standard/components/TableForm";

export default function Policy({ value, onChange }) {
  const fields = [
    {
      name: "topic",
      label: "Topic",
      type: "text",
    },
    {
      name: "salesService",
      label: "Sales Services",
      type: "number",
    },
    {
      name: "salesPart",
      label: "Sales Part",
      type: "number",
    },
    {
      name: "salesMachine",
      label: "Sales Machine",
      type: "number",
    },
  ];

  return (
    <div>
      <TableForm
        fields={fields}
        label="Number of Project"
        values={value.numberOfProjects}
        onChange={(value) => {
          onChange({ name: "numberOfProjects", value: value });
        }}
      />
    </div>
  );
}
